import {
  CheckoutErrorType,
  checkoutErrorAtom,
} from '~teacher/components/Account/atoms';
import { defaultStore } from '~teacher/jotai/defaultStore';

import teacherRouter from '../../../routers/teacher-router';

export function handleCheckoutError(errorType: string) {
  defaultStore.set(checkoutErrorAtom, errorType as CheckoutErrorType);
  teacherRouter.navigate('profile/billing', { trigger: true, replace: true });
}
